export async function withUploadErrorHandler(
  handler: (files: File[]) => Promise<unknown>,
  files: File[]
): Promise<void> {
  try {
    await handler(files);
  } catch (err) {
    window.Alert.alert({ title: err instanceof Error ? err.message : String(err) });
  }
}
